import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { setIsInOfficeUpload } from "app/store/manualUpload/slice/manualUploadSlice";
import React from "react";
import { useDispatch } from "react-redux";
import InOfficeFileUpload from "../forms/fileUpload/InOfficeFileUpload";
import useInOfficeFileUpload from "../forms/fileUpload/useInOfficeFileUpload";
import { useSelector } from "react-redux";

const InOfficeFileUploadModal = ({ handleInOfficeUpload }) => {
  const dispatch = useDispatch();
  const { cancelFile } = useInOfficeFileUpload({
    handlePatientSelect: () => {},
  });
  const { isUploadingInOfficeFile } = useSelector(
    (state) => state.manualUpload
  );

  const onClose = () => {
    cancelFile();
    dispatch(setIsInOfficeUpload(false));
  };

  return (
    <div>
      <ModalWrapper
        show={true}
        showTitle={true}
        maxWidth="md"
        maxHeight="sm"
        showCloseIcon={true}
        headerStyle={{ padding: "4px 24px" }}
        onClose={onClose}
        title="Upload In-Office Note File"
        children={<InOfficeFileUpload />}
        actionButtons={[
          {
            label: "Cancel",
            variant: "outlined",
            color: "secondary",
            onClick: onClose,
            disabled: isUploadingInOfficeFile,
          },
          {
            label: "Upload",
            variant: "contained",
            color: "secondary",
            onClick: handleInOfficeUpload,
            isLoading: isUploadingInOfficeFile,
          },
        ]}
      />
    </div>
  );
};

export default InOfficeFileUploadModal;
